import React, { Component } from 'react';
import { OrderVolumeFilter } from './order-volume/order-volume-filter.component';
import TemRequest from './../reports/order-volume/tem-request.component';
import AgeingProgress from './order-volume/ageing-progress.component';
import './report-page.component.css';

class OrderVolumePage extends Component {

    render() {
        return (
            <div>
                <div className="container-mt-7 report-main-container">
                    <OrderVolumeFilter />
                    <TemRequest />
                    <AgeingProgress />
                </div>
            </div>
        )
    }

}

export default OrderVolumePage;
